<template>
    <div class="qksm qksm4">
        <h4>四、财政拨款收入支出决算总体情况说明</h4>
        <div class="nogap">
            <p>
                2021年度财政拨款收、支总计{{isMoney(T4.总计)}}万元。
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable editLast" name="财政拨款去年" v-model:value="T4['总计_last']"></reason>万元）
                </span>
                <span v-if="num(T4.总计).toFixed(2)==num(T4['总计_last']).toFixed(2)">
                    与2020年决算数相同。
                </span>
                <span v-else>
                    与2020年度相比，财政拨款收、支总计各{{growthValueText(T4.总计,T4['总计_last'])}}万元，
                    <span v-if="T4.总计!=T4['总计_last'] && num(T4['总计_last'])!=0">
                        {{growthRatioText(T4.总计,T4['总计_last'])}}。
                    </span>
                    主要是<reason type="textarea" classname="qksm widest because" name="财政拨款原因"
                               :placeholder="num(T4.总计) < num(T4['总计_last'])? '……减少' : '……增加'" v-model:value="qksm['财政拨款原因']"></reason>
                </span>
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm4",
        data() {
            var qksm = this.$store.state.divData.qksm;
            if (qksm['财政拨款去年'])
                this.T4['总计_last'] = qksm['财政拨款去年'];
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
            }
        },

        props: {
            T4: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
        computed: {
            总计_last() {
                return this.isMoney(this.T4.总计_last)
            }
        },
        watch: {
            总计_last() {
                this.$parent.isChart()
            }
        },
    };
</script>